import React from 'react'
import { StyledLink } from '../../../../../../theme/Global'
import { StyledNonLinkLocationName } from './styles'

const LocationCell = (props) => {
  const productMap = props.location.productMap
  const productMapKeys = productMap ? Object.keys(productMap) : []

  const paidLeaveProductKeys = ['paidSickLeave', 'paidFamilyMedicalLeave', 'paidLeave']
  const relevantProductMapKeys = productMapKeys.filter((key) => paidLeaveProductKeys.includes(key))
  return (
    <p style={{ 'padding-top': '4px' }}>
      {relevantProductMapKeys.length > 0
        ? <StyledLink to={`/paidLeave/details/${props.location.id}`}>{props.location.name}</StyledLink>
        : <StyledNonLinkLocationName>{props.location.name}</StyledNonLinkLocationName>}
    </p>
  )
}


export default LocationCell
